/**
 * @fileoverview Performance monitoring utilities
 * @module lib/performance
 */

import { onCLS, onLCP, onFCP, onTTFB, onINP, type Metric } from 'web-vitals';

/**
 * Log performance metrics to console (development) or send to analytics (production).
 */
function reportMetric(_metric: Metric): void {
  // Production: metrics are collected but not logged
  // Could be extended to send to analytics service
}

/**
 * Initialize web vitals monitoring.
 * Call this once at app startup.
 */
export function initWebVitals(): void {
  onCLS(reportMetric);
  onLCP(reportMetric);
  onFCP(reportMetric);
  onTTFB(reportMetric);
  onINP(reportMetric);
}

/**
 * Mark the start of a performance measurement.
 */
export function perfStart(name: string): void {
  if (typeof performance !== 'undefined') {
    performance.mark(`${name}-start`);
  }
}

/**
 * Mark the end of a performance measurement and log the duration.
 */
export function perfEnd(name: string): void {
  if (typeof performance !== 'undefined') {
    performance.mark(`${name}-end`);
    try {
      performance.measure(name, `${name}-start`, `${name}-end`);
    } catch {
      // Ignore if marks don't exist
    }
  }
}

/**
 * React component profiler callback for debugging render performance.
 * Use with React.Profiler component.
 */
export function onRenderCallback(
  _id: string,
  _phase: 'mount' | 'update',
  _actualDuration: number,
  _baseDuration: number,
  _startTime: number,
  _commitTime: number
): void {
  // Production: profiling data collected but not logged
}
